"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");

var _Reflect$construct = require("@babel/runtime-corejs3/core-js-stable/reflect/construct");

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../lib/utils");

var _tooltip = _interopRequireDefault(require("../tooltip/tooltip"));

var _badge = _interopRequireDefault(require("../badge/badge"));

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TextTruncate = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(TextTruncate, _PureComponent);

  var _super = _createSuper(TextTruncate);

  function TextTruncate(props) {
    var _context, _context2;

    var _this;

    (0, _classCallCheck2["default"])(this, TextTruncate);
    _this = _super.call(this, props);
    _this.element = /*#__PURE__*/_react["default"].createRef();
    _this.original = props.text;
    _this.watch = true;
    _this.lineHeight = 0;
    _this.start = 0;
    _this.middle = 0;
    _this.end = 0;
    _this.state = {
      expanded: true,
      noClamp: false,
      text: props.text.substring(0, 20)
    };
    _this.action = (0, _bind["default"])(_context = _this.action).call(_context, (0, _assertThisInitialized2["default"])(_this));
    _this.clickHandler = (0, _bind["default"])(_context2 = _this.clickHandler).call(_context2, (0, _assertThisInitialized2["default"])(_this));
    _this.debounced = (0, _utils.debounce)(_this.action, 300);
    return _this;
  }

  (0, _createClass2["default"])(TextTruncate, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var text = this.props.text;

      if (text) {
        this.lineHeight = this.element.current.clientHeight + 1;
        this.clampLines();

        if (this.watch) {
          window.addEventListener("resize", this.debounced);
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("resize", this.debounced);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var text = this.props.text;

      if (prevProps.text !== text) {
        this.original = text;
        this.clampLines();
      }
    }
  }, {
    key: "action",
    value: function action() {
      var expanded = this.state.expanded;

      if (this.watch) {
        this.setState({
          noClamp: false
        });
        this.clampLines();
        this.setState({
          expanded: !expanded
        });
      }
    }
  }, {
    key: "clampLines",
    value: function clampLines() {
      var _context4, _context5;

      var lines = this.props.lines;
      if (!this.element.current) return;
      this.setState({
        text: ""
      });
      var maxHeight = this.lineHeight * lines + 1;
      this.start = 0;
      this.middle = 0;
      this.end = this.original.length;

      while (this.start <= this.end) {
        var _context3;

        this.middle = Math.floor((this.start + this.end) / 2);
        this.element.current.innerText = (0, _slice["default"])(_context3 = this.original).call(_context3, 0, this.middle);

        if (this.middle === this.original.length) {
          this.setState({
            text: this.original,
            noClamp: true
          });
          return;
        }

        this.moveMarkers(maxHeight);
      }

      this.element.current.innerText = (0, _slice["default"])(_context4 = this.original).call(_context4, 0, this.middle - 4) + this.getEllipsis();
      this.setState({
        text: (0, _slice["default"])(_context5 = this.original).call(_context5, 0, this.middle - 4) + this.getEllipsis()
      });
    }
  }, {
    key: "moveMarkers",
    value: function moveMarkers(maxHeight) {
      if (this.element.current.clientHeight <= maxHeight) {
        this.start = this.middle + 1;
      } else {
        this.end = this.middle - 1;
      }
    }
  }, {
    key: "getEllipsis",
    value: function getEllipsis() {
      var noClamp = this.state.noClamp;
      return this.watch && !noClamp ? "..." : "";
    }
  }, {
    key: "getButton",
    value: function getButton() {
      var noClamp = this.state.noClamp;
      var showMoreButton = this.props.showMoreButton;
      if (noClamp || !showMoreButton) return;
      var buttonText = this.watch ? "More" : "Less"; // eslint-disable-next-line consistent-return

      return /*#__PURE__*/_react["default"].createElement(_badge["default"], {
        className: "oui-ml-0",
        label: buttonText,
        onClick: this.clickHandler
      });
    }
  }, {
    key: "clickHandler",
    value: function clickHandler(_, e) {
      var expanded = this.state.expanded;
      e.preventDefault();
      this.watch = !this.watch;

      if (this.watch) {
        this.clampLines();
      } else {
        this.setState({
          text: this.original
        });
      }

      this.setState({
        expanded: !expanded
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var tooltipContent = this.original;
      var _this$props = this.props,
          text = _this$props.text,
          _this$props$tooltipCo = _this$props.tooltipConfig,
          _this$props$tooltipCo2 = _this$props$tooltipCo.placement,
          placement = _this$props$tooltipCo2 === void 0 ? "auto" : _this$props$tooltipCo2,
          customRenderer = _this$props$tooltipCo.customRenderer,
          maxWidth = _this$props$tooltipCo.maxWidth,
          textAlign = _this$props$tooltipCo.textAlign;
      var _this$state = this.state,
          textToShow = _this$state.text,
          noClamp = _this$state.noClamp;

      if ((0, _utils.isFunction)(customRenderer)) {
        tooltipContent = function tooltipContent() {
          return customRenderer(_this2.original);
        };
      }

      if (!text) {
        return null;
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _utils.gatherClasses)(this.props)
      }, !noClamp && this.watch ? /*#__PURE__*/_react["default"].createElement(_tooltip["default"], {
        text: tooltipContent,
        placement: placement,
        maxWidth: maxWidth,
        textAlign: textAlign
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "oui-mb-1",
        ref: this.element
      }, textToShow)) : /*#__PURE__*/_react["default"].createElement("div", {
        className: "oui-mb-1",
        ref: this.element
      }, textToShow), this.getButton());
    }
  }]);
  return TextTruncate;
}(_react.PureComponent);

TextTruncate.propTypes = {
  text: _propTypes["default"].string.isRequired,
  lines: _propTypes["default"].number,
  showMoreButton: _propTypes["default"].bool,
  tooltipConfig: _propTypes["default"].shape({
    placement: _propTypes["default"].oneOf(["auto", "top", "right", "bottom", "left"]),
    textAlign: _propTypes["default"].oneOf(["left", "center", "right"]),
    maxWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
    customRenderer: _propTypes["default"].func
  })
};
TextTruncate.defaultProps = {
  // eslint-disable-next-line react/default-props-match-prop-types
  text: "",
  lines: 3,
  showMoreButton: true,
  tooltipConfig: {}
};
var _default = TextTruncate;
exports["default"] = _default;